<div (click)="onTableClick($event)" class="ai-chat-table-scroll">
  <ds-table-component
    [columns]="columns"
    [data]="pagedRows"
    [caption]="caption"
    [emptyText]="'No data'"
    [withPagination]="allRows.length > paginationThreshold"
  ></ds-table-component>
</div>
@if (allRows.length > paginationThreshold) {
  <ds-pagination-v2
    [page]="currentPage"
    [pageSize]="pageSize"
    [collectionSize]="allRows.length"
    [paginationForTable]="true"
    [mobileLayout]="!isExpanded()"
    (pageChange)="onPageChange($event)"
    (pageSizeChange)="onPageSizeChange($event)"
  ></ds-pagination-v2>
}
